import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { SAT_COMPLIANCE_STATUS_COLOR_MAP } from 'constants/colorMaps'

import { complianceLabel } from 'utils/satCompliance'

import Badge from 'components/Shared/Badge/Index'

const SatComplianceBadge = ({ status, margin = '0', big = false }) => {
  const { t } = useTranslation()

  if (!status) {
    return null
  }

  return (
    <Badge
      color={SAT_COMPLIANCE_STATUS_COLOR_MAP[status]}
      margin={margin}
      big={big}
      data-test='sat-compliance-badge'
    >
      {complianceLabel(t, status)}
    </Badge>
  )
}

SatComplianceBadge.propTypes = {
  status: PropTypes.string,
  margin: PropTypes.string,
  big: PropTypes.bool,
}

export default SatComplianceBadge
